import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Heading } from "@chakra-ui/react";
import { Divider } from "./Divider";

export const DividerSection: FC = () => {
  const { t } = useTranslation();

  return (
    <Flex align="center" justify="center" w="full">
      <Divider />
      <Heading
        px={4}
        variant={{ base: "th-h4", md: "th-h5" }}
        whiteSpace="nowrap"
      >
        {t("planSelect.divider")}
      </Heading>
      <Divider />
    </Flex>
  );
};
